export enum WhoCanShareWithEnum {
  NONE = 'NONE',
  ALL = 'ALL',
  GROUPS = 'GROUPS',
}
